import { Button, Divider, Stack, Text, Title } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import AuthFlowPageShell, { authFlowPageShellStyles } from '@/components/shared/AuthFlowPageShell';
import AuthPageBackLink from '@/components/shared/AuthPageBackLink';
import Loader from '@/components/ui/Loader';
import { ROUTES } from '@/configs/routes';
import { useLocalStore } from '@/hooks/useLocalStore';
import { LoginMethodPageStore } from '@/stores/pages/LoginMethodPageStore';
import { isNativeWebView, openGoBackFromAuth } from '@/utils/nativeWebView';

import s from './LoginMethodPage.module.scss';

const LoginMethodPage: React.FC = () => {
  const navigate = useNavigate();
  const store = useLocalStore(() => new LoginMethodPageStore());

  const isPhoneOnly = store.isPhoneOnly;
  const isAlfaAvailable = store.isAlfaAvailable;

  const handlePhone = React.useCallback(() => {
    navigate(ROUTES.auth.phoneLogin.create());
  }, [navigate]);

  // Единственный способ входа — телефон: без промежуточного экрана выбора сразу ведём на вход по телефону.
  React.useEffect(() => {
    if (isPhoneOnly) {
      navigate(ROUTES.auth.phoneLogin.create(), { replace: true });
    }
  }, [isPhoneOnly, navigate]);

  if (isPhoneOnly) {
    return <Loader fullHeight />;
  }

  const showBackLink = isNativeWebView();

  return (
    <AuthFlowPageShell>
      <div className={s.root}>
        {showBackLink && <AuthPageBackLink onClick={openGoBackFromAuth} />}
        <Stack className={s.root__body} gap="lg" align="center" justify="center" flex={1}>
          <Stack gap="xs" align="center">
            <Title order={2} className={authFlowPageShellStyles.root__title} ta="center">
              Требуется авторизация
            </Title>
            <Text className={authFlowPageShellStyles.root__text} ta="center">
              Выберите способ входа в систему.
            </Text>
          </Stack>
          <Stack gap="sm" w="100%">
            {isAlfaAvailable && (
              <>
                <Button
                  fullWidth
                  onClick={store.redirectToAlfa}
                  className={authFlowPageShellStyles.root__button}
                  rightSection={<IconArrowRight size={18} />}
                  loading={store.loadAlfaUrlMeta.isLoading}
                >
                  Войти через Alfa-ID
                </Button>
                <Divider label="или" labelPosition="center" className={s.root__divider} />
              </>
            )}
            <Button fullWidth variant="outline" onClick={handlePhone} className={s.root__button_outline}>
              Войти по номеру телефона
            </Button>
          </Stack>
        </Stack>
      </div>
    </AuthFlowPageShell>
  );
};

export default observer(LoginMethodPage);
